import { ArrowLeft, Mail } from "lucide-react";

const questions = [
  ["Che cos'è Gestione Password?", "È un'applicazione web di AC Digital App per organizzare credenziali personali e password in un vault protetto da autenticazione."],
  ["Quali piani sono disponibili?", "Il piano Free consente fino a 10 password. Il piano Premium costa 2,99 € al mese e include password illimitate."],
  ["Come vengono protette le credenziali?", "L'accesso richiede email e password. Le comunicazioni avvengono su HTTPS e le voci del vault sono cifrate prima del salvataggio."],
  ["Come posso richiedere assistenza o la cancellazione dell'account?", "Puoi contattare AC Digital App all'indirizzo acdigital.app@gmail.com."],
];

export default function FaqPage({ onBack }) {
  return <main className="min-h-screen bg-[#F8FAFC] px-6 py-10" data-testid="faq-page">
    <div className="mx-auto max-w-3xl">
      <a href="/" onClick={function (event) { event.preventDefault(); onBack(); }} className="mb-8 inline-flex items-center gap-2 text-sm font-semibold text-green-700 hover:text-green-800" data-testid="faq-back-link">
        <ArrowLeft className="h-4 w-4" /> Torna all'accesso
      </a>
      <header className="border-b border-slate-200 pb-8">
        <p className="text-sm font-semibold text-green-700">AC Digital App</p>
        <h1 className="mt-2 text-4xl font-bold text-slate-900">Domande frequenti</h1>
        <p className="mt-3 max-w-2xl text-base text-slate-600">Informazioni chiare su Gestione Password, piani disponibili, protezione delle credenziali e assistenza.</p>
      </header>
      <section className="divide-y divide-slate-200" aria-label="Domande frequenti Gestione Password" data-testid="faq-list">
        {questions.map(function ([question, answer], index) {
          return <article className="py-7" key={question} data-testid={`faq-item-${index + 1}`}>
            <h2 className="text-lg font-semibold text-slate-900">{question}</h2>
            <p className="mt-2 text-base leading-7 text-slate-600">{answer}</p>
          </article>;
        })}
      </section>
      <footer className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-3 border-t border-slate-200 pt-6 text-sm text-slate-600">
        <a href="mailto:acdigital.app@gmail.com" className="inline-flex items-center gap-2 text-green-700 hover:text-green-800" data-testid="faq-support-link"><Mail className="h-4 w-4" /> Contatta l'assistenza</a>
        <a href="/privacy" className="hover:text-slate-900" data-testid="faq-privacy-link">Privacy</a>
        <a href="/terms" className="hover:text-slate-900" data-testid="faq-terms-link">Termini</a>
      </footer>
    </div>
  </main>;
}